module.exports = __webpack_public_path__ + "img/2.61938a00.png";